import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

// TODO: Refactor this response as it's repeated with the marketplace
export default class GetPurchaseOrdersValidationResultsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [{
                "process_result": {
                    "purchase_order": {
                        "number": "123456789",
                        "emission_date": "12-12-2024",
                        "order_number": "987654321"
                    },
                    "customers_edi_code_validator": true,
                    "delivery_sites_edi_code_validator": true,
                    "customers_articles_edi_code_validator": true,
                    "articles_prices_validator": true,
                    "available_delivery_date_validator": true,
                    "all_article_eans_enabled_validator": true
                },
                "customers_business_name": "Business name",
                "delivery_sites_name": "Delivery Site name"
            }],
            errors: []
        }
    }

    purchaseOrdersValidationResults() {
        return this.content().map(result => {
            return {
                purchaseOrderNumber: result.process_result.purchase_order.number,
                purchaseOrderEmissionDate: this._adaptEmissionDate(result.process_result.purchase_order.emission_date),
                clientBusinessName: result.customers_business_name,
                deliverySiteName: result.delivery_sites_name,
                customersEDICodeValidationResult: result.process_result.customers_edi_code_validator,
                deliverySitesEDICodeValidationResult: result.process_result.delivery_sites_edi_code_validator,
                customersArticlesEDICodeValidationResult: result.process_result.customers_articles_edi_code_validator,
                articlePricesValidationResult: result.process_result.articles_prices_validator,
                availableDeliveryDateValidationResult: result.process_result.available_delivery_date_validator,
                allArticleEansEnabledValidationResult: result.process_result.all_article_eans_enabled_validator,
                orderNumber: result.process_result.purchase_order.order_number,

            }
        })
    }

    _adaptEmissionDate(emissionDate) {
        return dayjs(emissionDate, 'DD-MM-YYYY');
    }

}